import { supabase } from "@/integrations/supabase/client";

interface BatchInviteParams {
  workspaceId: string;
  invites: Array<{
    email: string;
    role: 'admin' | 'member';
  }>;
  createdBy: string;
}

interface BatchInviteResult {
  successful: number;
  failed: number;
  errors: Array<{ email: string; error: string }>;
}

export async function createBatchInvites({ 
  workspaceId, 
  invites, 
  createdBy 
}: BatchInviteParams): Promise<BatchInviteResult> {
  const result: BatchInviteResult = {
    successful: 0,
    failed: 0,
    errors: [],
  };

  for (const invite of invites) {
    try {
      // Create invite record
      const { data: inviteData, error: inviteError } = await supabase
        .from('workspace_invites')
        .insert({
          workspace_id: workspaceId,
          email: invite.email,
          role: invite.role,
          created_by: createdBy,
        })
        .select()
        .single();

      if (inviteError) throw inviteError;

      // Send invite email via edge function
      const { error: emailError } = await supabase.functions.invoke('send-team-invite', {
        body: {
          inviteId: inviteData.id,
          email: invite.email,
          workspaceId: workspaceId,
        },
      });

      if (emailError) {
        console.error(`Failed to send email to ${invite.email}:`, emailError);
        // Don't fail the whole process if email fails, just log it
      }

      result.successful++;
    } catch (error: any) {
      result.failed++;
      result.errors.push({
        email: invite.email,
        error: error.message || 'Unbekannter Fehler',
      });
      console.error(`Failed to invite ${invite.email}:`, error);
    }
  }

  return result;
}
